<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>
<div class="container">
  <div class="loading" *ngIf="loading">
    <div class="spinner-border" role="status"></div>
  </div>
  <div class="container-product" *ngIf="!loading">
    <div class="header">
      <h1 class="title">{{'EDIT_PRODUCT' | translate}} {{product.product.productCode}}</h1>
      <app-back-arrow [routerLink]="['/products', productId]" routerLinkActive="router-link-active"></app-back-arrow>
    </div>

    <div class="container-product-type" *ngIf="false">
      <div class="form-card">
        <label class="form-label"> {{'PRODUCT_TYPE' | translate}}</label>
        <div class="form-group-container top-container">
          <div class="form-group couple">
            <div class="form-check form-control-lg">
              <input class="form-check-input radio-type" type="radio" name="product-type" id="productType" value="1" (change)="changeProductType($event)" [checked]="productType == 1">
              <label class="form-check-label">
                Producto convencional
                {{'CONVENTIONAL_PRODUCT' | translate}}
              </label>
            </div>
          </div>
          <div class="form-group couple">
            <div class="form-check form-control-lg">
              <input class="form-check-input radio-type" type="radio" name="product-type" id="productType" value="2" (change)="changeProductType($event)" [checked]="productType == 2">
              <label class="form-check-label">
                Producto de Sesiones
                {{'SESSIONS_PRODUCT' | translate}}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-card">
      <input type="hidden" id="product_id" name="id" value="{{productId}}" />

      <div class="info-container">
        <div class="form-label">{{'STATUS' | translate}}:</div>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="product.product.productIsActive" id="flexCheckChecked">
          <span class="slider round"></span>
        </label>
        <span class="switch-text">{{ product.product.productIsActive ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}</span>
      </div>

      <div class="form-label">{{'IMAGES' | translate}}:</div>
      <div class="images-container">
        <div cdkDropList cdkDropListOrientation="horizontal" class="image-list" (cdkDropListDropped)="drop($event)">
          <div class="image-box" cdkDragDisabled>
            <button class="add-img" (click)="selectImage(0)">+</button>
            <input id="btn-upload" type="file" class="d-none" (change)="onFileSelected($event)">
          </div>
          <div class="image-box" *ngFor="let image of generalImages; let i = index" cdkDrag>
            <div class="image-placeholder" *cdkDragPlaceholder></div>
            <img [src]="image.url" />
            <button type="button" class="btn btn-danger delete-button" (click)="deleteProductImage(image.url)">
              x
            </button>
            <!-- <button type="button" class="btn btn-link download-button" (click)="downloadImage(i)">
              <i class="feather" data-feather="download"></i>
            </button> -->
          </div>
        </div>
      </div>

      <div class="form-group-container">
        <div class="form-group couple">
          <label class="form-label" for="product_name">{{'NAME' | translate}}</label>
          <input type="text" class="form-control" id="product_name" name="name" placeholder="Nombre del producto"
            value="{{product.product.productName}}" (keyup)="changeName($event)"/>
        </div>
        <div class="form-group couple" *ngIf="productType == 2">
          <label class="form-label is-required" for="product_sesions">{{'SESSIONS' | translate}}</label>
          <input type="number" min="0" class="form-control" id="product_sesions" name="name" placeholder="Cantidad de sesiones" value="{{product.product.productSessions}}" (keyup)="changeSesions($event)"/>
        </div>
      </div>

      <div class="form-group-container">
        <div class="form-group trio">
          <label class="form-label" for="product_category">{{'CATEGORY' | translate}}</label>
          <select class="form-select" id="product_category" name="category" (change)="changeCategory($event); resetSubcategories()">
            <option value="0" selected disabled hidden>{{'SELECT_CATEGORY' | translate}}</option>
            <option *ngFor="let category of categories" [value]="category.categoryId" [selected]="category.categoryId == product.product.productCategoryId">
              {{ category.categoryName }}
            </option>
          </select>
        </div>
        <div class="form-group trio">
          <label class="form-label" for="product_subcategory">{{"SUBCATEGORY" | translate}}</label>
          <select class="form-select" id="product_subcategory" name="subcategory" (change)="changeSubCategory($event); resetSubSubcategories()">
            <option value="0">{{'SELECT_SUBCATEGORY' | translate}}</option>
            <ng-container *ngFor="let subCategory of subCategories">
              <option [value]="subCategory.subCategoryId" [selected]="subCategory.subCategoryId == product.product.productSubCategoryId">
                {{ subCategory.subCategoryName }}
              </option>
            </ng-container>
          </select>
        </div>
        <div class="form-group trio">
          <label class="form-label" for="product_subsubcategory">{{'SUB_SUBCATEGORY' | translate}}</label>
          <select class="form-select" id="product_subsubcategory" name="subsubcategory" (change)="changeSubSubCategory($event)">
            <option value="0">{{'SELECT_SUB_SUBCATEGORY' | translate}}</option>
            <ng-container *ngFor="let subSubCategory of subSubCategories">
              <option [value]="subSubCategory.subSubCategoryId" [selected]="subSubCategory.subSubCategoryId == product.product.productSubSubCategoryId">
                {{ subSubCategory.subSubCategoryName }}
              </option>
            </ng-container>
          </select>
        </div>
      </div>

      <div class="form-group-container">
        <div class="form-group trio">
          <label class="form-label" for="product_industryType">{{'INDUSTRY' | translate}}</label>
          <select class="form-select" id="product_industryType" name="industryType" (change)="changeIndustry($event)">
            <option selected disabled hidden>{{'SELECT_INDUSTRY' | translate}}</option>
            <option *ngFor="let industryType of industryTypes" [value]="industryType.industryTypeId" [selected]="industryType.industryTypeId==product.product.productIndustryTypeId">
              {{ industryType.industryTypeName }}
            </option>
          </select>
        </div>
        <div class="form-group trio">
          <label class="form-label" for="product_supplier">{{'SUPPLIER' | translate}}</label>
          <select class="form-select" id="product_supplier" name="supplier" (change)="changeSupplier($event)">
            <option  value="0">{{"SELECT_SUPPLIER" | translate}}</option>
            <option *ngFor="let supplier of suppliers" [value]="supplier.supplierId" [selected]="supplier.supplierId==product.product.productSupplierId">
              {{ supplier.supplierName }}
            </option>
          </select>
        </div>

        <div class="form-group trio">
          <label class="form-label" for="product_collection">{{'COLLECTION' | translate}}</label>
          <select class="form-select" id="product_collection" name="collection" (change)="changeCollection($event)">
            <option  value="0">{{'SELECT_COLLECTION' | translate}}</option>
            <option *ngFor="let collection of collections" [value]="collection.collectionId" [selected]="collection.collectionId==product.product.productCollectionId">
              {{ collection.collectionName }}
            </option>
          </select>
        </div>

      </div>

      <div class="form-group-container" *ngIf="canUseExternalRedirect && productType == 1">
        <div class="form-group couple external-url-group">
          <label class="form-label" for="external_url">{{"EXTERNAL_PRODUCT_URL" | translate}}</label>
          <input
            type="text"
            class="form-control"
            id="external_url"
            name="external_url"
            placeholder="https://example.com/product"
            [value]="product.product.externalUrl || ''"
            [disabled]="!product.product.externalRedirectEnabled"
            [ngClass]="{'is-invalid': showExternalUrlInvalid()}"
            (input)="onExternalUrlChange($event)"
          />
          <div class="d-flex flex-column justify-space-between">
            <small class="text-danger" *ngIf="showExternalUrlInvalid()">
              {{'INVALID_URL_FORMAT' | translate}}
            </small>
            <small class="text-muted">
              {{'EXTERNAL_URL_INFO' | translate}}
            </small>
          </div>
        </div>
        <div class="form-group couple external-redirect-toggle">
          <div class="form-check mt-4">
            <input
              class="form-check-input"
              type="checkbox"
              id="external_redirect_enabled"
              name="external_redirect_enabled"
              [checked]="product.product.externalRedirectEnabled"
              (change)="onExternalRedirectToggle($event)"
            />
            <label class="form-check-label" for="external_redirect_enabled">
              {{"ENEABLE_EXTERNAL_REDIRECT" | translate}}
            </label>
          </div>
        </div>
      </div>

      <div class="pdfs-content">
        <div class="form-group-container">
          <div class="form-group-pdf pdf-uploader">
            <label for="pdfInput" class="form-label">{{'UPLOAD_PDF' | translate}}</label>
            <div class="custom-file-input">
              <input
                type="file"
                class="form-control file-input"
                id="pdfInput"
                accept="application/pdf"
                (change)="onFileSelectedPDF($event)"
              />

              <label for="pdfInput" class="file-label">
                {{ pdfFileName || ('NO_FILE_SELECTED' | translate) }}
              </label>
            </div>
          </div>

          <div class="pdf-button">
            <button
              class="btn btn-outline-secondary submit-btn"
              (click)="openPdfInNewTab()"
              [disabled]="!pdfSrc"
            >
            {{'VIEW_PDF' | translate}}
            </button>
          </div>
        </div>
      </div>

      <div class="info-container description">
        <div class="form-label">{{'DESCRIPTION' | translate}}:</div>
        <div class="description-card ql-editor visually-hidden" id="description"></div>
      </div>
      <!-- [customOptions]="customOptions" -->
      <quill-editor class="description-editor" [styles]="{
                  borderRadius: '0 0 10px 10px',
                  padding: '5px',
                  marginBottom: '2vh'
                }" [theme]="'snow'" id="description-edit" [modules]="modules" [(ngModel)]="product.product.productDescription"
        (onEditorChanged)="descriptionChanged($event)"></quill-editor>

      <div class="info-container description">
        <div class="form-label">{{'CONDITIONS' | translate}}:</div>
        <div class="description-card ql-editor visually-hidden" id="description"></div>
      </div>
      <!-- [customOptions]="customOptions" -->
      <quill-editor class="description-editor" [styles]="{
        borderRadius: '0 0 10px 10px',
        padding: '5px',
        marginBottom: '2vh'}" 
        [theme]="'snow'" id="conditions-edit" [modules]="modules" [(ngModel)]="product.product.productConditions">
      </quill-editor>
    </div>

     <div class="form-card" *ngIf="productType === 4">
      <h1 class="title">{{ 'ADD_PRODUCT_TO_PACKAGE' | translate }}</h1>
      <div class="row g-2 mb-3">
        <div class="d-flex align-items-center justify-content-between mt-3">
          <label class="form-label">{{ 'FILTERS' | translate }}:</label>
          <div class="col-md-2 d-flex align-items-center mt-3">
            <div class="form-check form-switch">
              <input
                #chk
                class="form-check-input"
                type="checkbox"
                id="chkActive"
                [checked]="filters.onlyActive"
                (change)="toggleOnlyActive(chk.checked)"
              />
              <label class="form-check-label" for="chkActive">Solo activos</label>
            </div>
          </div>
        </div>

        <!-- FILTERS -->
        <div class="row g-2">
          <div class="col-md-2 form-floating">
            <input
              type="text"
              class="form-control w-100"
              id="txtSearch"
              placeholder="Buscar"
              (input)="onSearchChange($any($event.target).value)"
            />
            <label for="txtSearch">🔍 Buscar</label>
          </div>
          
            <div class="col-md-2 form-floating">
              <select class="form-select w-100" id="selCat"

                      [(ngModel)]="filters.categoryId"
                      (ngModelChange)="onCategoryChange($event)"
                      [ngModelOptions]="{standalone: true}">
                <option [ngValue]="0">{{ 'ALL' | translate }}</option>
               <option *ngFor="let c of (categories ?? [])" [ngValue]="c.categoryId">{{ c.categoryName }}</option>
              </select>
              <label for="selCat">{{ 'CATEGORY' | translate }}</label>
            </div>
            <div class="col-md-2 form-floating">
              <select class="form-select w-100" id="selSubCat"
                      [disabled]="!(subCategoriesForFilters?.length)"
                      [(ngModel)]="filters.subCategoryId"
                      (ngModelChange)="onSubCategoryChange($event)"
                      [ngModelOptions]="{standalone: true}">
                <option [ngValue]="0">{{ 'ALL' | translate }}</option>
                <option *ngFor="let s of subCategoriesForFilters" [ngValue]="s.subCategoryId">{{ s.subCategoryName }}</option>
              </select>
              <label for="selSubCat">{{ 'SUBCATEGORY' | translate }}</label>
            </div>
            <div class="col-md-2 form-floating mt-2">
              <select class="form-select w-100" id="selSubSubCat"
                      [disabled]="!(subSubCategoriesForFilters?.length)"
                      [(ngModel)]="filters.subSubCategoryId"
                      (ngModelChange)="onSubSubCategoryChange($event)"
                      [ngModelOptions]="{standalone: true}">
                <option [ngValue]="0">{{ 'ALL' | translate }}</option>
                <option *ngFor="let s of subSubCategoriesForFilters" [ngValue]="s.subSubCategoryId">{{ s.subSubCategoryName }}</option>
              </select>
              <label for="selSubSubCat">{{ 'SUB_SUBCATEGORY' | translate }}</label>
            </div>
            <div class="col-md-2 form-floating mt-2">
              <select class="form-select w-100" id="selCollection"
                      [(ngModel)]="filters.collectionId"
                      (ngModelChange)="onCollectionChange($event)"
                      [ngModelOptions]="{standalone: true}">
                <option [ngValue]="0">{{ 'ALL' | translate }}</option>
                 <option *ngFor="let col of (collections ?? [])" [ngValue]="col.collectionId">{{ col.collectionName }}</option>
              </select>
              <label for="selCollection">{{ 'COLLECTION' | translate }}</label>
            </div>
            <div class="col-md-2 form-floating mt-2">
              <select class="form-select w-100" id="selSupplier"
                      [(ngModel)]="filters.supplierId"
                      (ngModelChange)="onSupplierChange($event)"
                      [ngModelOptions]="{standalone: true}">
                <option [ngValue]="0">{{ 'ALL' | translate }}</option>
                 <option *ngFor="let sup of (suppliers ?? [])" [ngValue]="sup.supplierId">{{ sup.supplierName }}</option>
              </select>
              <label for="selSupplier">{{ 'SUPPLIER' | translate }}</label>
            </div>
        </div>
      </div>

      <div class="d-flex justify-content-between">
        <div class="mt-2 col-md-8">
          <ng-container *ngIf="selected.length; else noTags">
            <span *ngFor="let s of selected" class="badge m-2 bg-primary p-2">
              {{ s.productName }}
              <button
                type="button"
                class="btn-close btn-close-white btn-sm ms-1"
                aria-label="Remove"
                (click)="toggleProduct(s)">
              </button>
            </span>
          </ng-container>
          <ng-template #noTags></ng-template>
        </div>
        <div class="d-flex align-items-center justify-content-end col-md-4">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-success"
                    (click)="showProducts()" [disabled]="filterLoading">
              {{ 'SHOW_PRODUCTS' | translate}}
            </button>
            <button type="button" class="btn btn-outline-secondary"
                    (click)="resetFilters()" [disabled]="filterLoading">
              {{ 'RESET_FILTERS' | translate}}
            </button>
          </div>
        </div>
      </div>

      <span class="badge w-auto col-md-2 mt-2 bg-secondary">
        {{ productPackageItems.length }} {{ 'SELECTED' | translate }}
      </span>

      <hr class="mt-3" />

      <div *ngIf="filtersUsed && !filterLoading" class="d-flex align-items-center gap-2 mb-3">
        <label class="form-label mb-0">{{ 'SHOW' | translate }}:</label>
        <select
          class="form-select mb-0 w-auto"
          [(ngModel)]="filters.amount"
          (change)="changePageSize()"
        >
          <option [value]="1">1</option>
          <option [value]="5">5</option>
          <option [value]="10">10</option>
          <option [value]="25">25</option>
          <option [value]="50">50</option>
          <option [value]="100">100</option>
        </select>

        <span class="ms-3">
          {{ total }} {{ 'RESULT' | translate }}{{ total === 1 ? '' : 's' }} ·
          {{ totalPages }} {{ 'PAGE' | translate }}{{ totalPages === 1 ? '' : 's' }}
        </span>
      </div>

      <div class="text-center my-3" *ngIf="filterLoading">
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <table class="table table-hover align-middle"  *ngIf="filtersUsed && !filterLoading">
        <thead class="table-light">
          <tr>
            <th style="width:48px"></th>
            <th>{{ 'NAME' | translate }}</th>
            <th>{{ 'CODE' | translate }}</th>
            <th>{{ 'IMAGE' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of catalog">
            <td class="text-center">
              <input
                type="checkbox"
                class="form-check-input"
                [checked]="isSelected(p.productId)"
                (change)="toggleProduct(p)"
              />
            </td>
            <td>{{ p.productName }}</td>
            <td>{{ p.productCode }}</td>
            <td>
              <img
                *ngIf="p.imageURL"
                [src]="p.imageURL"
                class="img-thumbnail"
                style="max-width:48px"
              />
              <img *ngIf="!p.imageURL" src="/assets/static/missing-image.png" />
            </td>
          </tr>
        </tbody>
      </table>

      <div  *ngIf="filtersUsed && !filterLoading" class="d-flex justify-content-center align-items-center gap-2 mt-3">
        <button class="btn btn-link" (click)="prevPage()" [disabled]="!hasPrev">
          ⬅ {{ 'PREVIOUS' | translate }}
        </button>

        <ng-container *ngFor="let p of pages">
          <button
            *ngIf="p !== '…'"
            class="btn"
            [class.btn-outline-secondary]="(filters.counter + 1) !== p"
            [class.btn-info]="(filters.counter + 1) === p"
            (click)="goToPage(p)"
          >
            {{ p }}
          </button>
          <span *ngIf="p === '…'" class="px-2">…</span>
        </ng-container>

        <button class="btn btn-link" (click)="nextPage()" [disabled]="!hasNext">
          {{ 'NEXT' | translate }} ➡
        </button>
      </div>
    </div>

    <div class="form-card">
      <h1 class="title">{{'PRICE' | translate}}</h1>
      <div class="form-group-container">
        <div class="form-group trio">
          <label class="form-label" for="product_cost">{{'COST_PRICE' | translate}}</label>
          <input type="number" min="0" class="form-control" id="product_cost" name="cost" placeholder="0.00"
            value="{{product.product.productBaseCost}}" (input)="changeBaseCost($event)"  />
        </div>
        <div class="form-group trio">
          <label class="form-label" for="product_gainmargin">{{'MARGIN'| translate}}</label>
          <input type="number" min="0" class="form-control" id="product_gainmargin" name="gainmargin" placeholder="0%"
            value="{{product.product.gainMargin}}" (input)="changeGainMargin($event)"/>
        </div>
        <div class="form-group trio">
          <label class="form-label" for="product_tax">{{'TAX' | translate}}</label>
          <select class="form-select" id="product_tax" name="tax" (change)="changeTax($event)" >
            <option *ngFor="let tax of taxes" [value]="tax.taxId" [selected]="product.product.productTaxId == tax.taxId">
              {{ tax.taxName }}
            </option>
          </select>
        </div>
      </div>
      
      <hr class="page-separator">
      
      <div class="form-group-container">
        <div class="form-group trio">
          <label class="form-label" for="product_endprice">{{'SALE_PRICE' | translate}}</label>
          <input type="number" min="0" class="form-control" id="product_endprice" name="endprice" placeholder="Precio final"
          value="{{product.product.productSellPrice || 0}}" (input)="changeSellPrice($event)" [disabled]="false"/>
        </div>
        <div class="form-group trio">
          <label class="form-label" for="product_sale">{{'DISCOUNT_PRICE' | translate}}</label>
          <input type="number" min="0" class="form-control" id="product_sale" name="sale" placeholder="0" (keyup)="changeDiscountPrice($event)" value="{{ product.product.productDiscountPrice || 0 }}" />
        </div>
        <div class="form-group trio">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="hidePrice" [(ngModel)]="product.product.hidePrice">
            <label class="form-check-label" for="hidePrice">
              {{'HIDE_PRICE_TO_CUSTOMER' | translate}}
            </label>
          </div>
        </div>
      </div>
        <div class="form-group-container gap-2">
          <div class="form-group trio">
            <label class="form-label is-required" for="productPaymentMode">
              {{'PAYMENT_MODE' | translate}}
            </label>
            <select
              class="form-select"
              id="productPaymentMode"
              name="productPaymentMode"
              [(ngModel)]="product.product.productPaymentMode"
            >
              <option [ngValue]="1">Pago único</option>
              <option [ngValue]="2">Pago Recurrente</option>
            </select>
          </div>
        </div>
    </div>

    <div class="buttons-variants-container" *ngIf="productType == 1 || productType == 3 || productType == 4">
      <h1 class="title">{{'VARIANTS' | translate}}</h1>
      <button type="button" class="btn btn-success confirm-btn visually-hidden" >
        {{ 'ADD_VARIANTS' | translate }}
      </button>
    </div>

    <ng-container *ngIf="productType == 1 || productType == 3 || productType == 4">
    <div class="variant-container form-card" *ngFor="let variant of variants;let indexOfelement = index;">
      <div>
        <label class="form-label" for="product_variable_type">
          {{'TYPE' | translate}}
        </label>
        <input list="product_variable_type1" name="varieble_type" class="form-control"
          placeholder="{{ 'ENTER_TYPE' | translate }}" value="{{variant.variantTypeName}}" id="type{{indexOfelement}}" (keyup)="changeVariantTypeName($event)"/>
        <datalist id="product_variable_type1">
          <option value="Tamaño">
          <option value="Color">
          <option value="Material">
          <option value="Estilo">
        </datalist>
      </div>
      <div class="value-label" >
        <label class="form-label" for="product_variable_value">{{'VALUE' | translate}}</label>
        <button id="valBtn1" type="button" class="btn btn-outline-secondary small-btn-value confirm-btn text-white" (click)="addVariantValue(indexOfelement)" [disabled]="emptyVariantValue">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 5 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus" _ngcontent-eos-c103=""><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
        </button>
        <div id="product_variable_container1formVar1" class="value-container" *ngFor="let variantValue of variant.variantValues;let indexOfvalue = index;">
          <input type="text" class="form-control variant-value variantValueInput formVar1" placeholder="{{'ENTER_VALUE' | translate}}" value="{{variantValue.variantValueName}}" name="type{{indexOfelement}}" id="id{{indexOfvalue}}" (input)="changeVariantValue($event)">
          <button type="button" class="btn btn-outline-secondary variantValueInput delVariantBtn small-btn cancel-btn" (click)="deleteVariantValue(indexOfelement, variantValue.variantValueId)">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash" _ngcontent-hyp-c84=""><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
          </button>
        </div>
      </div>
      <div class="delete-btn-container">
        <button type="button" class="btn btn-outline-secondary cancel-btn" (click)="deleteVariant(indexOfelement)">
          {{ 'REMOVE_VARIANT' | translate }}
        </button>
      </div>
    </div>
  </ng-container>

    <div class="variant-actions-container" *ngIf="variants.length < 3 && (productType == 1 || productType == 3 || productType == 4)">
      <button type="button" class="btn btn-outline-secondary confirm-btn" (click)="addVariant()">
         {{ 'ADD_VARIANTS' | translate }}
      </button>
    </div>


    <div class="form-card">
      <div class="d-flex justify-content-end align-items-center">
        <div>
          <select class="form-select" [(ngModel)]="activeShopPoint" (change)="changeShopPoint()">
            <option value="0" selected="" ng-reflect-value="0">{{ 'ALL_BRANCHS' | translate }}</option>
            <option *ngFor="let shopPoint of shopPoints" [value]="shopPoint.shopPointId">{{shopPoint.shopPointName}}</option>
          </select>
        </div>
      </div>
      <h1 class="variantsTitle"> {{ 'VARIANT_LIST' | translate }}</h1>
      <div id="itemCombinationList">
        <div *ngFor="let item of items" class="container-fluid item">
          <div class="row">
            <div class="col-md-8 mt-2 d-flex justify-content-between" [class]="{'col-md-12': product.product.productType != 3 || product.product.productType != 4}">
              <h4 class="subtitle mb-0">{{objectValueJoin(item)}}</h4>
              <div class="d-flex justify-content-end" *ngIf="product.product.productType == 3  || product.product.productType == 4">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" attr.data-itemId="{{item.itemId}}" [checked]="item.itemHolder == 1" (input)="changeItemHolder($event)">
                  <label class="form-check-label" for="flexSwitchCheckDefault">{{'REQUIRED_HOLDER' | translate}}</label>
                </div>
                <div class="form-label m-0" hidden>{{'REQUIRED_HOLDER' | translate}}</div>
                <label class="switch" hidden>
                  <input type="checkbox" (change)="changeItemHolder($event)" [checked]="item.itemHolder == 1" attr.data-itemId="{{item.itemId}}">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
            <div class="col-md-2 form-floating mt-2">
              <input class="form-control mb-0" id="code{{item.itemCode}}" attr.data-itemId="{{item.itemId}}" type="text" value="{{item.itemCode}}" (blur)="changeItemcode($event)">
              <label class="ms-2" for="code{{item.itemCode}}">{{'CODE' | translate}}</label>
            </div>
            <div class="col-md-2 form-floating mt-2">
              <input class="form-control mb-0" id="price{{item.itemCode}}" attr.data-itemId="{{item.itemId}}" type="number" value="{{ item.itemPrice }}" (input)="changeitemPrice($event)">
              <label class="ms-2" for="price{{item.itemCode}}">{{'PRICE' | translate}}{{'' | translate}}</label>
            </div>
            <div class="col-md-2 form-floating mt-2">
              <input class="form-control mb-0" id="discountPrice{{item.itemCode}}" attr.data-itemId="{{item.itemId}}" type="number" value="{{ item.itemDiscountPrice }}" (input)="changeitemDiscountPrice($event)">
              <label class="ms-2" for="discountPrice{{item.itemCode}}">{{ 'DISCOUNT_PRICE' | translate }}</label>
            </div>
            <div class="col-md-2 form-floating mt-2" *ngIf="product.product.productType == 3 || product.product.productType == 4">
              <input class="form-control mb-0" id="beneficiaries{{item.itemCode}}" attr.data-itemId="{{item.itemId}}" type="number" value="{{ item.itemBeneficiaries }}" (input)="changeitemBeneficiaries($event)">
              <label class="ms-2" for="beneficiaries{{item.itemCode}}">{{ 'BENEFICIARIES' | translate }}</label>
            </div>

            <div class="col-md-2 mt-1" *ngIf="product.product.productType == 2">
              <label class="ms-2">{{'QUANTITY' | translate}}</label>
              <input [hidden]="activeShopPoint != 0" class="form-control quantityInput quantityMain" disabled="true" attr.data-shoppoint="0" data-item="0" value="{{item.itemTotalStock}}">
              <div class="shop-points-quantities" *ngFor="let shopPoint of item.itemShopPoints" [hidden]="activeShopPoint != shopPoint.shopPointId">
                <select class="form-control mb-0 no-variant-unlimited" attr.data-itemId="{{item.itemId}}" attr.data-shoppoint="{{shopPoint.shopPointId}}" (change)="changeitemShopPointUnlimited($event)">
                  <option value="0" [selected]="shopPoint.itemUnlimited == 0">{{'LIMITED' | translate}}</option>
                  <option value="1" [selected]="shopPoint.itemUnlimited == 1">{{'UNLIMITED' | translate}}</option>
                </select>
                <input
                type="number"
                class="form-control mb-0 no-variant-quantity"
                attr.data-shoppoint="{{shopPoint.shopPointId}}"
                attr.data-itemId="{{item.itemId}}"
                value="{{shopPoint.itemQuantity}}"
                (input)="changeitemShopPointQuantity($event)"
                [disabled]="shopPoint.itemUnlimited == 1"
                />
              </div>
            </div>

            <div class="col-md-2 form-floating mt-2" *ngIf="product.product.productType == 1 || product.product.productType == 3 || product.product.productType == 4">
              <input [hidden]="activeShopPoint != 0" class="form-control quantityInput quantityMain" disabled="true" attr.data-shoppoint="0" data-item="0" value="{{item.itemTotalStock}}">
              <input *ngFor="let shopPoint of item.itemShopPoints; index as i" [hidden]="activeShopPoint != shopPoint.shopPointId" class="form-control quantityInput" attr.data-shoppoint="{{shopPoint.shopPointId}}" attr.data-itemId="{{item.itemId}}" type="" value="{{shopPoint.itemQuantity}}" (input)="changeitemShopPointQuantity($event)">
              <label class="ms-2">{{'QUANTITY' | translate}}</label>
            </div>
            <div class="col-md-2 images-container">
              <img src="{{getImageByItem(item.itemId)}}" class="w-50" alt="item image {{item.itemId}}">
              <div class="images-list">
                <div class="image-box" cdkDragDisabled>
                  <button class="add-img btn-add-single-img" (click)="openSelectImageMoldal(item.itemId)">+</button>
                </div>
              </div>
            </div>
          </div>
        <div class="col-md-12 mt-2" *ngIf="product.product.productType == 3 || product.product.productType == 4">
          <label class="form-label">Parentescos</label>
          <div class="d-flex flex-wrap gap-2">
            <div class="form-check form-check-inline" *ngFor="let relation of relationshipOptions">
              <input class="form-check-input" type="checkbox"
                [id]="'relationship-' + item.itemId + '-' + relation"
                [checked]="item.itemRelationship?.includes(relation)"
                (change)="toggleItemRelationship(item.itemId, relation)">
              <label class="form-check-label" [for]="'relationship-' + item.itemId + '-' + relation">
                {{ relation }}
              </label>
            </div>
          </div>
        </div>
        </div>
      </div>
      <small hidden class="form-text text-muted" *ngIf="productType == 2"><strong class="text-danger">*</strong>{{'UNLIMITED_HELP_TEXT' | translate}}</small>
    </div>

    <!-- <div class="form-card">
      <div class="value-container">
        <label class="form-label" for="product_variable_type">
          Listado de Variantes
        </label>
        <button type="button" class="btn btn-outline-secondary confirm-btn visually-hidden">
          Actualizar Listado de Variantes
        </button>
      </div>
      <div class="info-container">
        <table class="table table-bordered table-hover" id="variantsCombinationsTable">
          <thead>
            <th scope="col" class="table-start">Item</th>
            <th scope="col">Código</th>
            <th scope="col">Cantidad</th>
            <th scope="col" >Precio</th>
            <th scope="col">Precio Descuento</th>
            <th scope="col"></th>
            <th scope="col" class="table-end"></th>
          </thead>
          <tbody id="variantsList">
            <tr *ngFor="let item of items" id="{{item.itemId}}">
              <td>{{objectValueJoin(item)}}</td>
              <td><input type="text" class="form-control" (blur)="changeItemcode($event)" value="{{item.itemCode}}"></td>
              <td><input type="number" min="0" class="form-control" (input)="changeitemQuantity($event)" value="{{item.itemQuantity}}"></td>
              <td><input type="number" min="0" class="form-control" (input)="changeitemPrice($event)" value="{{ item.itemPrice }}"></td>
              <td><input type="number" min="0" class="form-control" (input)="changeitemDiscountPrice($event)" value="{{ item.itemDiscountPrice }}"></td>
              <td><img src="{{getImageByItem(item.itemId)}}" alt="item image {{item.itemId}}"></td>
              <td class="images-container">
                <div class="images-list">
                  <div class="image-box" cdkDragDisabled>
                    <button class="add-img btn-add-single-img" (click)="openSelectImageMoldal(item.itemId)">+</button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
    <div class="alert alert-danger align-items-center" [hidden]="duplicatedVariants == false" role="alert" *ngIf="productType == 1 || productType == 3 || productType == 4">
      <div class="d-flex">
        <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 1024 463.43" height="18" padding=""><path d="M189.46 44.02c34.26-58.66 99.16-58.77 133.24.12l.97 1.81 175.27 304.4c33.71 56.4-1.2 113.76-66.17 112.96v.12H73.53c-.9 0-1.78-.04-2.66-.11-58.34-.79-86.64-54.22-61.9-106.84.39-.85.82-1.67 1.28-2.46l-.04-.03 179.3-309.94-.05-.03zm50.32 302.4c4.26-4.13 9.35-6.19 14.45-6.56 3.4-.24 6.8.29 9.94 1.48 3.13 1.19 6.01 3.03 8.39 5.41 6.92 6.91 8.72 17.38 4.64 26.16-2.69 5.8-7.08 9.7-12.11 11.78-3.03 1.27-6.3 1.84-9.56 1.76-3.27-.08-6.49-.82-9.41-2.18-5.02-2.33-9.3-6.43-11.7-12.2-2.65-6.36-2.27-12.96.63-19.15 1.15-2.46 2.75-4.81 4.73-6.5zm33.86-47.07c-.8 19.91-34.51 19.93-35.28-.01-3.41-34.1-12.13-110.53-11.85-142.58.28-9.87 8.47-15.72 18.94-17.95 3.23-.69 6.78-1.03 10.35-1.02 3.6.01 7.16.36 10.39 1.05 10.82 2.3 19.31 8.39 19.31 18.45l-.05 1-11.81 141.06z" fill="#212121cc"></path></svg>
        <div>
          {{ 'DUPLICATE_VARIANT_VALUES' | translate }}
        </div>
      </div>
    </div>
    <div class="buttons-container">
      <button type="button" class="btn btn-success submit-btn" [disabled]="!enabledSave" (click)="saveChanges()">
        {{ 'SAVE_CHANGES' | translate }}
      </button>
    </div>

  </div>
</div>

<div class="modal product-modal" id="productLoadingModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content product-modal-content">
      <div class="modal-body product-modal-body">
        <div class="loading">
          <div class="spinner-border" role="status"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal success-edit-product-modal" id="successEditProductModal" tabindex="-1">
  <div class="modal-dialog success-edit-product-dialog" role="document">
    <div class="modal-content success-edit-product-content">
      <div class="modal-body success-edit-product-body text-center">
        <div class="success-check-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none"
               stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="14 26 22 34 38 18" />
          </svg>
        </div>
        <h3 class="mt-3">{{ 'SUCCESS' | translate }}</h3>
        <p>{{ 'PRODUCT_CHANGES_SAVED_SUCCESS' | translate }}</p>
      </div>
      <div class="success-edit-product-footer modal-footer justify-content-center gap-2">
        <button type="button"
                [routerLink]="['/products', productId]"
                class="btn btn-success confirm-btn"
                (click)="closeModal()">
          {{ 'BACK_TO_PRODUCT' | translate }}
        </button>
        <button type="button"
                class="btn btn-outline-danger cancel-btn"
                (click)="closeModal()">
          {{ 'CLOSE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="validationModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content product-modal-content">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{'ALERT' | translate}}!</h3>
        <p class="text-center">{{ 'EMPTY_VALUES_NOT_ALLOWED' | translate }}</p>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-danger cancel-btn" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="selectImagesModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog modal-lg" role="document">
    <div class="modal-content product-modal-content">
      <div class="modal-body product-modal-body">
        <input type="text" id="item-image" class="d-none">
        <input type="text" id="image" class="d-none">
        <div class="images-container">
          <div cdkDropList cdkDropListOrientation="horizontal" class="image-list row" (cdkDropListDropped)="drop($event)">
            <div class="image-box col-2" cdkDragDisabled>
              <button class="add-img" (click)="selectImage(1)">+</button>
              <input id="btn-upload" type="file" class="d-none" (change)="onFileSelected($event)">
            </div>
            <div class="image-box col-2" *ngFor="let image of generalImages" cdkDrag>
              <a href="javascript:;" (click)="asociateImage(image.url)">
                <div class="image-placeholder" *cdkDragPlaceholder></div>
                <img [src]="image.url" [ngClass]="{'selected': image.url === selectedImage}"/>
                <div class="check-icon" [innerHTML]="checkIcon"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-outline-secondary confirm-btn" (click)="confirmImage()">
          {{'CONFIRM' | translate}}
        </button>
        <button type="button" class="btn btn-danger cancel-btn" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade" id="errorEditProductModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
      <div class="modal-body error-modal-body">
        <h3 class="text-center">{{"ERROR" | translate}}</h3>
        <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade" id="errorProductModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
      <div class="modal-body error-modal-body">
        <h3 class="text-center">{{"ERROR" | translate}}</h3>
        <p class="text-center">{{'MAX_SIZES' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
